import { useLayoutEffect, useMemo, useRef } from 'react';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import { useIsMounted } from '@hooks/useIsMounted';
import ScrollMagic from 'scrollmagic';
import { gsap } from 'gsap';

export const useFlexibleRSVPQuestionsSectionController = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const backgroundPhotoElRef = useRef<HTMLDivElement>(null);
  const scrollController = useScrollController();
  const isMounted = useIsMounted();
  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;
    let sectionTimeline: ReturnType<typeof gsap.timeline>;
    const sectionEl = sectionRef.current;
    if (scrollController && isMounted && sectionEl) {
      const initTimeline = () => {
        sectionTimeline = gsap.timeline({ paused: true });
        sectionTimeline.to(
          backgroundPhotoElRef.current,
          {
            scale: 1.4,
            top: -300,
            delay: 4,
          },
          1
        );
      };
      const initScene = () => {
        scene = new ScrollMagic.Scene({
          triggerElement: sectionEl,
          triggerHook: 'onCenter',
          duration: '300%',
        })
          .addTo(scrollController)
          .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
            sectionTimeline?.progress(event.progress);
          });
      };
      initTimeline();
      initScene();
    }
    const clearScene = () => {
      if (sectionTimeline) {
        sectionTimeline.progress(0);
        sectionTimeline.kill();
      }
      if (scene) {
        scene.destroy(true);
      }
    };
    return () => {
      clearScene();
    };
  }, [scrollController, isMounted, sectionRef]);
  return {
    sectionRef,
    backgroundPhotoElRef,
  };
};
